<template>
	<div class="omapi-woocommerce-settings omapi-woocommerce-settings__active">
		<label>
			<div>
				<common-tooltip
					tooltip="Select output settings specifically for your WooCommerce store."
					class="setting-label inline"
				>
						<span>Show on WooCommerce Pages:</span>
				</common-tooltip>
				<core-button
					type="secondary omapi-woocommerce-settings__select-all"
					@click.prevent="selectAllOrNone"
				>{{ selectAll ? 'Select None' : 'Select All' }}</core-button>
			</div>
		</label>

		<div class="omapi-radio-group omapi-input">
			<common-selectable-input
				v-for="(setting) in contextualSettings"
				type="checkbox"
				class="text-setting"
				:class="{'text-setting-indented': setting.isEndpoint}"
				:value="values[setting.id]"
				:checked="isChecked(setting)"
				:key="setting.id"
				:name="setting.id"
				:label="setting.label"
				@input="setWooValue"
			/>
		</div>

		<campaigns-taxonomies-settings
			v-if="!isLoading"
			:campaign="campaign"
			:taxonomies="wooTaxonomies"
			labelPrefix="Show on WooCommerce "
		/>
	</div>
</template>

<script lang="js">
import { mapState } from 'vuex'
import { campaign } from '@/campaigns/mixins/campaign'
import { wooSettings } from '@/campaigns/data'

export default  {
	mixins : [ campaign ],
	props  : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	data () {
		return {
			settings : wooSettings,
		}
	},
	computed : {
		...mapState('wp', [ 'taxonomies' ]),
		isLoading () {
			return !this.$store.getters.isFetched('wpResources')
		},
		contextualSettings () {
			return this.settings.filter(setting => {
				return !setting.show || setting.show === this.campaignType
			}).map(s => {
				s.isEndpoint = this.isEndpoint(s.id)
				return s
			})
		},
		values () {
			const values = {}
			this.settings.forEach(setting => {
				const key = `campaign.wp.post_meta._omapi_${setting.id}`
				values[setting.id] = '1' === this.$get(key) ? '1' : '0'
			})

			return values
		},
		selectAll () {
			return '1' === this.values.show_on_woocommerce
		},
		allEndpoints () {
			return '1' === this.values.is_wc_endpoint
		},
		wooTaxonomies () {
			return this.filterTaxonomies((tax) => {
				return this.isWooTaxonomy(tax) && 0 < tax.terms.length
			})
		},
	},
	methods : {
		doShow (id) {
			return '1' === this.values[id]
		},
		isEndpoint (id) {
			return 0 === id.indexOf('is_wc_endpoint_')
		},
		isChecked (setting) {
			return this.selectAll || this.doShow(setting.id) || (this.allEndpoints && setting.isEndpoint)
		},
		setWooValue ({ target }) {
			const { name : id } = target

			const value = '1' === this.values[id] ? '0' : '1'

			this.updateValue(id, value)

			this.setChecked(id, value)
		},
		setChecked (id, value) {
			const allChecked = this.contextualSettings.every(s => '1' === this.values[s.id])

			this.updateValue('show_on_woocommerce', allChecked ? '1' : '0')

			if (!this.isEndpoint(id)) {
				return
			}

			const allEndpointsChecked = this.contextualSettings.every(s => {
				return !s.isEndpoint || this.doShow(s.id)
			})

			this.updateValue('is_wc_endpoint', allEndpointsChecked ? '1' : '0')
		},
		selectAllOrNone () {
			this.updateValue('show_on_woocommerce', this.selectAll ? '0' : '1')
		},
		updateValue (id, value) {
			this.updateCampaignValue({
				campaignId : this.id,
				key        : `wp.post_meta._omapi_${id}`,
				value,
				valueType  : 'numericBool',
			})
		},
	},
}
</script>
<style>
	.text-setting-indented {
		padding-left: 26px;
	}
</style>
